import { c as _c } from "react/compiler-runtime";
import { Box, Switch, Text } from "@chakra-ui/react";
const getToggleCss = (color: string, disabled: boolean) => disabled ? {
  "& span[data-state]": {
    backgroundColor: "var(--chakra-colors-grey-200)"
  },
  "& span[data-state] > span": {
    backgroundColor: "var(--chakra-colors-grey-400)"
  }
} : {
  "& span[data-state=checked]": {
    backgroundColor: color
  },
  "& span[data-state=checked] > span": {
    backgroundColor: "white",
    scale: "0.65"
  },
  "& span[data-state=unchecked]": {
    backgroundColor: "transparent",
    boxShadow: `inset 0 0 0 2px ${color}`
  },
  "& span[data-state=unchecked] > span": {
    backgroundColor: color,
    scale: "0.65"
  }
};
export interface ColorToggleProps {
  color: string;
  checked: boolean;
  onToggle: () => void;
  label: string;
  labelPosition?: "bottom" | "end";
  disabled?: boolean;
  "data-testid"?: string;
}
export const ColorToggle = t0 => {
  const $ = _c(20);
  const {
    color,
    checked,
    onToggle,
    label,
    labelPosition: t1,
    disabled: t2,
    "data-testid": dataTestId
  } = t0;
  const labelPosition = t1 === undefined ? "bottom" : t1;
  const disabled = t2 === undefined ? false : t2;
  const isBottom = labelPosition === "bottom";
  const t3 = isBottom ? "column" : "row";
  const t4 = isBottom ? "2" : "3";
  const t5 = disabled ? false : checked;
  let t6;
  if ($[0] !== color || $[1] !== disabled) {
    t6 = getToggleCss(color, disabled);
    $[0] = color;
    $[1] = disabled;
    $[2] = t6;
  } else {
    t6 = $[2];
  }
  let t7;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Switch.HiddenInput />;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  let t8;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Switch.Control><Switch.Thumb /></Switch.Control>;
    $[4] = t8;
  } else {
    t8 = $[4];
  }
  let t9;
  if ($[5] !== disabled || $[6] !== label || $[7] !== onToggle || $[8] !== t5 || $[9] !== t6) {
    t9 = <Switch.Root checked={t5} onCheckedChange={onToggle} disabled={disabled} aria-label={label} css={t6}>{t7}{t8}</Switch.Root>;
    $[5] = disabled;
    $[6] = label;
    $[7] = onToggle;
    $[8] = t5;
    $[9] = t6;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  const t10 = disabled ? "textMuted" : "text";
  let t11;
  if ($[11] !== label || $[12] !== t10) {
    t11 = <Text fontSize="sm" fontWeight="semibold" color={t10}>{label}</Text>;
    $[11] = label;
    $[12] = t10;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== dataTestId || $[15] !== t11 || $[16] !== t3 || $[17] !== t4 || $[18] !== t9) {
    t12 = <Box display="flex" flexDirection={t3} alignItems="center" gap={t4} data-testid={dataTestId}>{t9}{t11}</Box>;
    $[14] = dataTestId;
    $[15] = t11;
    $[16] = t3;
    $[17] = t4;
    $[18] = t9;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  return t12;
};